(function() {
    'use strict';

    angular.module('app.factories.controlLogicService', []) // app.factories.enum-module
        .factory('f_controllogicService', ['$rootScope', '$q', 'API', function($rootScope, $q, API) {

            var fetching;
            return {
                get: function() {
                    if (fetching === undefined) {
                        fetching = true;

                        var api = new API();
                        var clStatesPromise = api.System.GetControlLogicStates().$promise;
                        var clSettingsPromise = api.System.GetControlLogicSettings().$promise;

                        return $q.all([clStatesPromise, clSettingsPromise])
                            .finally(function() {
                                fetching = undefined;
                                $rootScope.loading = false;
                            });
                    }
                }

            };
        }]);
})();
